import { List, useRecordContext } from "react-admin";
import { DrivingSchool } from "../../providers/drivingSchoolsProvider";
import { LoadingIndicator } from "../../misc/LoadingIndicator";
import { PageTitle } from "../../misc/PageTitle";
import { grants } from "../../backoffice.access_control";
import { Row } from "../../misc/Row";
import { Button, IconButton } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { useNavigate } from "react-router";
import { EmptyState } from "../../misc/EmptyState";
import Alert from "@mui/material/Alert";
import { Column } from "../../misc/Column";
import { ResponsiveListSurface } from "../../misc/ResponsiveListSurface";
import { LabelsDataGrid } from "./LabelsDataGrid";

export function DrivingSchoolLabels() {
  const drivingSchool = useRecordContext<DrivingSchool>();
  const navigate = useNavigate();

  if (!drivingSchool) {
    return (
      <>
        <PageTitle>Fahrschüler-Labels</PageTitle>
        <LoadingIndicator />
      </>
    );
  }

  const empty = <EmptyState />;

  return (
    <Column>
      <Alert severity="info" sx={{ mb: 2 }}>
        Du kannst hier die Labels {grants.has("DrivingSchoolLabel:edit") ? "definieren" : "sehen"}, mit denen bestimmte
        Fahrschüler markiert werden können. Die Labels werden sowohl im Backoffice als auch in der AUTOVIO App für
        Fahrlehrer prominent angezeigt.
      </Alert>
      <div style={{ position: "relative" }}>
        <Row
          justifyContent="space-between"
          alignItems="center"
          sx={{ mb: "30px", minHeight: "32px", columnGap: 2, flexWrap: { xs: "wrap", sm: "nowrap" }, rowGap: 1 }}
        >
          <PageTitle documentTitle="Fahrschüler-Labels">
            <h2 style={{ margin: 0, lineHeight: 0.83 }}>Fahrschüler-Labels</h2>
          </PageTitle>
          {grants.has("DrivingSchoolLabel:create") && (
            <>
              <IconButton
                aria-label="Label hinzufügen"
                color="primary"
                onClick={() => navigate("/labels/create")}
                size="small"
                sx={{ display: { xs: "inline-flex", sm: "none" } }}
              >
                <AddIcon />
              </IconButton>
              <Button
                variant="outlined"
                startIcon={<AddIcon />}
                onClick={() => navigate("/labels/create")}
                size="small"
                sx={{ display: { xs: "none", sm: "inline-flex" } }}
              >
                Hinzufügen
              </Button>
            </>
          )}
        </Row>
        <ResponsiveListSurface variant="compactStandalone" data-testid="DrivingSchoolLabels">
          <List
            resource="labels"
            title=" "
            actions={false}
            filter={{ drivingSchoolId: drivingSchool.id }}
            sort={/* initial sort order: */ { field: "name", order: "ASC" }}
            exporter={false}
            hasCreate={false}
            empty={empty}
          >
            <LabelsDataGrid empty={empty} />
          </List>
        </ResponsiveListSurface>
      </div>
    </Column>
  );
}
